import React, { forwardRef } from 'react';
import classnames from 'classnames';
import s from './StickyContent.scss';
const StickyContent = /*#__PURE__*/ forwardRef(({ isStuck, className, zIndex, marginTop = 0, marginLeft = 0, top = 0, children }, innerRef)=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['content'], isStuck && s['stuck'], isStuck && className),
        style: {
            zIndex,
            marginTop: isStuck ? marginTop : undefined,
            marginLeft: isStuck ? marginLeft : undefined,
            top: isStuck ? top : undefined
        },
        ref: innerRef
    }, children(isStuck));
});
StickyContent.displayName = 'StickyContent';
export default /*#__PURE__*/ React.memo(StickyContent);
